module.exports = __webpack_public_path__ + "static/img/bot.32014cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/cpassChat/bot.png
// module id = gtqJ
// module chunks = 1